import script from "./ProjectPlanning.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectPlanning.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectPlanning.vue?vue&type=style&index=0&id=1592cc2d&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1592cc2d"]])

export default __exports__